import i18next from 'i18next'
import { toast } from 'sonner'

import { haptic } from '@/lib/haptics'

// A success toast with an Undo action; every undoable action shares this look.
export function undoToast(message: string, undo: () => void, duration = 4000) {
  toast.success(message, {
    duration,
    action: {
      label: i18next.t('common.undo', { defaultValue: 'Undo' }),
      onClick: () => {
        haptic()
        undo()
      },
    },
  })
}
